module.exports = __webpack_public_path__ + "3271e755d749cdedf270358e702deb72.png";